export default __webpack_public_path__ + "static/media/successCheck.251dbce9.svg";